import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import { Spinner } from "lib/components";
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
import { OperatorVariantAdd } from "./operator/features";
import { AdminVariantAdd } from "./admin/features";
import { ProviderVariantAdd } from "./provider/features";

const { userKey } = constant;
const { operator, provider, admin } = userKey;

const VariantAdd = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <Spinner />;
    }
    if (role === operator) {
      return <OperatorVariantAdd />;
    }
    if (role === provider) {
      return <ProviderVariantAdd />;
    }
    if (role === admin) {
      return <AdminVariantAdd />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const VariantAddComponent = getComponent(currentUserRole);
  return VariantAddComponent;
};

export default VariantAdd;
